import { analytics } from '@play-co/gcinstant';
import { eventGTM } from 'src/lib/analytics/events';
import { Tutorial } from 'src/replicant/buruburu/tutorial';
import { TutorialStep } from 'src/replicant/buruburu/tutorial/tutorial.ruleset';
import { showTutorial } from '../tutorial.util';
import { TutorialEvent } from '../TutorialController';
import { TutorialHandler } from './TutorialHandler';

export class CareForPetTutorial implements TutorialHandler {
  public readonly step: TutorialStep = 'careForPets';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'careMenuOpened') return false;

    await showTutorial('careForPets', {
      $stepIndex: 4,
      $stepName: 'care_for_pets_popup',
    });

    eventGTM('TutorialFinish');
    analytics.pushEvent('TutorialFinish', {
      version: Tutorial.ruleset.version,
    });

    return true;
  }
}
